/** Frontend product routes. Backend APIs (`/api/chat`, `/api/rag/chat/stream`) are unchanged. */

export const ASK_PATH = '/ask';
export const LIBRARY_PATH = '/library';
export const DESK_PATH = '/desk';
export const OPINIONS_PATH = '/opinions';

export function askHomePath(query?: string): string {
  if (!query?.trim()) return ASK_PATH;
  return `${ASK_PATH}?q=${encodeURIComponent(query.trim())}`;
}

export function askSessionPath(sessionId: string): string {
  return `${ASK_PATH}/${sessionId}`;
}

export function libraryDocumentPath(id: string | number): string {
  return `${LIBRARY_PATH}/documents/${id}`;
}

export function libraryQuestionPath(id: string): string {
  return `${LIBRARY_PATH}/questions/${id}`;
}

export function librarySearchPath(query?: string): string {
  if (!query?.trim()) return `${LIBRARY_PATH}/search`;
  return `${LIBRARY_PATH}/search?q=${encodeURIComponent(query.trim())}`;
}

export function libraryTopicFolderPath(slug: string, sub?: string): string {
  const base = `${LIBRARY_PATH}/${slug}`;
  if (!sub) return base;
  return `${base}?sub=${encodeURIComponent(sub)}`;
}

export function isAskPath(pathname: string): boolean {
  return pathname === ASK_PATH || pathname.startsWith(`${ASK_PATH}/`);
}

export function isLibraryPath(pathname: string): boolean {
  return pathname === LIBRARY_PATH || pathname.startsWith(`${LIBRARY_PATH}/`);
}

export function isDeskPath(pathname: string): boolean {
  return pathname === DESK_PATH || pathname.startsWith(`${DESK_PATH}/`);
}

export function opinionArticlePath(slug: string): string {
  return `${OPINIONS_PATH}/${slug}`;
}

export function isOpinionsPath(pathname: string): boolean {
  return pathname === OPINIONS_PATH || pathname.startsWith(`${OPINIONS_PATH}/`);
}
